import React, {useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { httpGet , crafterConf } from "@craftercms/classes";
import { composeUrl} from "@craftercms/utils";
import { languagePicker , removeIgnoreItems, getLabel} from '../../utils';
import queryString from 'query-string';
import { useLocation } from "react-router-dom";
import VideoPageHolder from './VideoPageStyle';
import ListItem from '../../components/ListItem/ListItem';
import Video from '../../components/Video/Video';
import SEO from '../../components/SEO/SEO';

const VideoPage = (props) => {
    const [title, setTitle] = useState([]);
    const [pageDetails, setPageDetails] = useState([]);
    const [tags, setTags] = useState([]);
    const [latestVideos, setLatestVideos] = useState([]);
    const locationState = useLocation();
    const [pageDesc, setPageDesc] = useState();
    const [videoThumb, setVideoThumb] = useState();
    const [program, setProgram] = useState();
    const [videoURL, setVideoURL] = useState();
    const [isCPACTV, setIsCPACTV] = useState(false);
    const [pageURL, setPageURL] = useState();
	const pageLang = props.current_lang;
	const pageLocale = pageLang + "_CA";
    const pageTitle = program ? title + " | " + program + " | CPAC.ca" : "CPAC.ca";

    useEffect(() => {
        let completeUrl = window.location.search;
		let params = queryString.parse(completeUrl);
        
        if (params.id) {
            const craftConf = crafterConf.getConfig();
            const serviceUrl = composeUrl(craftConf , process.env.REACT_APP_CONTENT_MODEL_ENDPOINT);

            httpGet(serviceUrl, {url: props.url, crafterSite: craftConf.site, "id":params.id}).subscribe((data) => {
                let fieldNames = [
                    "details;image_s","details;title_t","details;category_t", "details;categoryURL_s", "details;description_t",
                    "itemList;title_t", "itemList;seeAllUrl_s",
                    "itemList.title_t", "itemList.description_t", "itemList.image_s", "itemList.altImageTxt_s", "itemList.url_s",
                    "itemList.category_t", "itemList.categoryURL_s", "tags.name_s", "tags.description_t", "tags.url_t"
                ]
                
                languagePicker(data, fieldNames);
                let dataPage = data.page;

                if (dataPage.details){
                    setPageDetails(dataPage.details);
                    setTitle(dataPage.details.title);
                    if (dataPage.details.type && dataPage.details.type === "cpactv"){
                        setTitle("CPAC TV");
                        setIsCPACTV(true);
                    }
                    setPageDesc(dataPage.details.description.replace(/\n/g, " "));
                    setVideoThumb(dataPage.details.image);
                    setProgram(props.current_lang === "en" ? dataPage.details.category_en_t : dataPage.details.category_fr_t);
                    setVideoURL(dataPage.details.videoUrl);
                }
                
                if (dataPage.itemList){
                    setLatestVideos(dataPage.itemList);
                }    
              	// Removing dummy record added to force lists of 1 item
                if(data.page.tags && data.page.tags.item && data.page.tags.item.length > 0) {
                    data.page.tags.item = removeIgnoreItems(data.page.tags);
                    setTags(dataPage.tags.item)
                }
            });
            setPageURL(window.location.origin + window.location.pathname + "?id=" + params.id);
        }
    }, [props.url, props.current_lang, locationState]);

    useEffect(()=> {
        props.setCurrentLanguage(props.lan);
    },[props.lan]);

    // let robots = isCPACTV ? "false" : !program ? "false" : "true";

    return (
        <>
        <SEO pageDesc={pageDesc} pageURL={pageURL} title={title}  pageTitle={pageTitle} image={videoThumb} type="video.episode" robots="true" pageLocale={pageLocale} videoURL={videoURL} />
        <VideoPageHolder>
        <div itemScope="itemscope" itemType="https://schema.org/TVEpisode">
            <div className="row">
                <h1 className="page-title" tabIndex="0" itemProp="headline">
                    {pageDetails && pageDetails.type === "live" ? 
                        <div className="video-live-label">
							<img src="/static-assets/theme/svg/target.svg" alt="target-icon" />
							<span>{getLabel("LIVE")}</span>
						</div> : ""} {title}
                </h1>
            </div>
            <div className="content-wrapper-lspage" itemProp="mainEntityOfPage">
                    {pageDetails && <Video details={pageDetails} tags={tags} processPrelive={true}/>}
                    {latestVideos && <div className="content__right" itemScope itemType='https://schema.org/WPSideBar'> <ListItem items={latestVideos}/> </div>}
            </div> 
            </div>   
        </VideoPageHolder>
        </>
    )
}

const mapStateToProps = (store) => ({
    current_lang: store.language.current,
});

const mapDispatchToProps = (dispatch) => ({
    setCurrentLanguage: (lang) => dispatch({ type: 'SET_CUR_LANG', current: lang })
});

export default connect(mapStateToProps,mapDispatchToProps)(VideoPage);